/**
 * The front door. Three ways to play, and the difference between them stated
 * plainly enough that nobody has to open one to find out what it is.
 *
 * The scorekeeper is listed last but described first in most people's heads —
 * it is the mode you reach for with six real dice already on the table, and it
 * is the only one that works with no signal at all.
 */

import { RULE_CARD } from '@shared/scoring';
import { Eyebrow, Masthead, Page } from '../ui/shell';

export type Mode = 'online' | 'solo' | 'keeper';

export function Home({ onPick }: { onPick: (mode: Mode) => void }) {
  return (
    <Page>
      <Masthead sub="six dice · press your luck" />

      <button type="button" className="mode mode--primary" onClick={() => onPick('online')}>
        <Eyebrow>With friends</Eyebrow>
        <h2>Play online</h2>
        <p>Start a table, share a four-letter code, and play from anywhere. Up to eight.</p>
      </button>

      <button type="button" className="mode" onClick={() => onPick('solo')}>
        <Eyebrow>On your own</Eyebrow>
        <h2>Play the computer</h2>
        <p>Real dice, real decisions, opponents that know when to stop. Three difficulties.</p>
      </button>

      <button type="button" className="mode" onClick={() => onPick('keeper')}>
        <Eyebrow>Around a table</Eyebrow>
        <h2>Keep score</h2>
        <p>You have the dice. This does the arithmetic, the turn order and the undo.</p>
      </button>

      <div className="spacer" />

      <Eyebrow className="field-label">How dice score</Eyebrow>
      <div className="well--dark rule-sheet">
        <div className="rules">
          {RULE_CARD.map(([what, worth]) => (
            <div key={what}>
              <span>{what}</span>
              <span>{worth}</span>
            </div>
          ))}
        </div>
        <div className="fineprint">
          Set aside at least one scoring die, then choose: throw what is left, or bank what you have. Throw
          nothing and you farkle — the whole turn goes back to the house. Clear all six and you throw all six
          again.
        </div>
      </div>

      <div className="colophon">farkle.hobel.dev</div>
    </Page>
  );
}
